module.exports = __webpack_public_path__ + "static/media/SUBMONITOR.1498f1a4.jpg";